module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n        " + _vm._s(_vm.rangeDescription) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row sliderarea"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue2-slider', {
    ref: "slider",
    attrs: {
      "real-time": true,
      "show": true,
      "speed": 0,
      "value": _vm.currentValue,
      "min": _vm.min,
      "tooltip": false,
      "max": _vm.max,
      "height": 10,
      "bgStyle": {
        'backgroundColor': '#fff',
        'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.1)',
        'border': '0.1px solid #a6a6a6',
        'borderRadius': '20px'
      },
      "sliderStyle": [{
        'backgroundColor': '#00a3c4',
        'borderRadius': '5px'
      }, {
        'backgroundColor': '#032f5e',
        'borderRadius': '5px'
      }],
      "processStyle": {
        'backgroundImage': '-webkit-linear-gradient(left, #00a3c4, #032f5e)'
      }
    },
    on: {
      "click": _vm.startSlide,
      "drag-start": _vm.startSlide,
      "callback": _vm.changed,
      "drag-end": _vm.endSlide
    }
  })], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae701e22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rangeSlider.vue
// module id = 1281
// module chunks = 1